import React from "react";

export default function FormError({ error, touched }) {
  return (
    <div className="text-red-400 text-xs">{error && touched && error}</div>
  );
}
